import { startTransition } from 'react';
import CustomButton from './CustomButton';
import { ReactComponent as DoneShip } from 'assets/quote/doneShip.svg'
import { ReactComponent as DoneAir } from 'assets/quote/doneAir.svg'
import { useLocation, useNavigate } from 'react-router-dom';
import { quoteInfoAtom } from 'atom/quote';
import { useSetAtom } from 'jotai';
import { IQuote } from 'types/quote';
import Loading from './Loading';

interface IConfrimDialog {
    isOpen: boolean,
    type: string;
    uploadProgress?: number
}

const QuoteDoneDialog = ({ isOpen, type, uploadProgress = 100 }: IConfrimDialog) => {
    const location = useLocation();
    const navigate = useNavigate();
    const setQuoteInfo = useSetAtom(quoteInfoAtom)

    const goMain = () => {
        if (location.pathname === "/") {
            window.location.reload();
        }
        else {
            navigate("/", { replace: true });
            setTimeout(() => {
                setQuoteInfo({} as IQuote)
            }, 400)
        }
    }

    const goStatus = () => {
        startTransition(() => {
            navigate("/", { replace: true });
            setTimeout(() => {
                navigate("/quote/status/list", { replace: location.pathname === "/" ? false : true });
            }, 0);
        });
        setTimeout(() => {
            setQuoteInfo({} as IQuote)
        }, 400)
    }


    return (
        <div className="relative">
            {isOpen && (
                <div className="z-50 fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 px-4">
                    <div className="bg-white shadow-lg p-6 rounded-lg w-[660px] tablet:w-96 max-h-[80vh] overflow-y-auto">
                        <div className='flex flex-col gap-6 font-semibold text-center'>
                            <div className="flex justify-center items-center h-40">
                                {
                                    (uploadProgress < 100) ?
                                        <Loading width={200} /> :
                                        type === 'SEA' ? <DoneShip className='mobile:w-44' /> : <DoneAir className='mobile:w-44' />
                                }
                            </div>
                            {
                                (uploadProgress < 100) ?
                                    <div className='flex flex-col gap-3'>
                                        <p className='text-2xl'>견적서를 작성중입니다...</p>
                                        <p className='text-[#9D9EB7]'>업로드 : {uploadProgress} %</p>
                                    </div> :
                                    <div className='flex flex-col gap-3'>
                                        <p className='text-2xl'>견적 요청이 완료 되었습니다.</p>
                                        <p className='text-[#9D9EB7]'>세부 내역은 <span className='text-primary'>견적요청 → 견적현황</span> 에서 확인이 가능합니다</p>
                                    </div>

                            }
                            <div className="flex justify-center gap-4">
                                <CustomButton
                                    title={'메인 페이지'}
                                    onClick={goMain}
                                    className='hover:!bg-white disabled:hover:!bg-[#9D9EB7] !border-[#9D9EB7] w-[200px] !h-15 !text-[#9D9EB7] disabled:!text-white'
                                    disabled={uploadProgress !== 100}
                                />
                                <CustomButton
                                    title={'견적현황 바로가기'}
                                    onClick={goStatus}
                                    className={'w-[200px] !h-15 bg-primary'}
                                    disabled={uploadProgress !== 100}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default QuoteDoneDialog;